export default "__VITE_ASSET__Dp3Oj022__"